import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { DataTableColumnDefinition, DataTableRow } from './DataTableTypes.js';

export type DataTableColumnProps<
  TRow extends DataTableRow,
  TContext = unknown
> = React.HTMLAttributes<HTMLDivElement> & {
  column: DataTableColumnDefinition<TRow, TContext>;
  children: React.ReactNode;
};

export const DataTableColumn = styled(
  forwardRef(
    <TRow extends DataTableRow, TContext = unknown>(
      { children, ...restProps }: DataTableColumnProps<TRow, TContext>,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      return (
        <div ref={ref} {...restProps}>
          {children}
        </div>
      );
    }
  )
).withConfig({
  shouldForwardProp: (prop) => !['column'].includes(prop),
  displayName: 'DataTableColumn',
})`
  position: ${({ column }) => (column.pinned === true ? 'sticky' : 'static')};
  ${({ column }) => (column.pinned === true ? 'left: 0;' : '')}
  ${({ column }) => (column.pinned === true ? 'border-right: solid 1px #efefef;' : '')}
`;
